import { TextField, InputAdornment } from "@mui/material"

export default function Number({label, value, onChange, unit, required, min, max, step, sx}){

    return <TextField
        label={label || ''}
        type='number'
        value={value}
        onChange={onChange}
        InputProps={{
            endAdornment: <InputAdornment position='end'>{unit || '?'}</InputAdornment>,
            min: min || 0,
            max: max || 999999,
            step: step || 0.01,
        }}
        required={required ? true : false}
        size='small'
        sx={sx || {}}
    />
}